import { Text } from '@mantine/core';

const HomeView = () => {
    return (
        <Text
            c={'dimmed'}
            style={{ height: '100%', width: '100%', textAlign: 'center' }}
        >
            Select a file from the menu or add a new one.
        </Text>
    );
};

export default HomeView;
